import React from "react";
import { Link, mergeStyleSets } from "@fluentui/react";
import * as Messages from "../codegen/Messages";
import { footerHeight } from "../constants/uiConstants";

const classNames = mergeStyleSets({
  footerWrapper: {
    background: "#FFFFFF",
    position: "fixed",
    width: "100%",
    zIndex: "1000",
  },
  footerContainer: {
    bottom: "0",
    padding: "5px 20px",
    borderTop: "1px solid #b5bbc2",
    fontSize: "11px",
    height: footerHeight,
    boxSizing: "border-box",
  },
  privacyLink: {
    marginLeft: "6px",
    marginRight: "18px",
    textDecoration: "none",
    width: "inherit",
    outline: "none",
  },
  trusteLink: {
    width: "inherit",
    textDecoration: "none",
    outline: "none",
  },
  copyrightText: {
    color: "#686868",
    float: "right",
  },
});

const copyrightSymbol = "©";
const termsUrl = "http://www.oracle.com/legal/privacy/index.html";
const trusteScript = "//consent.truste.com/notice?domain=oracle.com&c=teconsent&text=true&gtm=1";

export const Footer = (): JSX.Element => {
  const date = new Date();
  const year = date.getFullYear().toString();

  return (
    <div className={classNames.footerWrapper}>
      <footer className={classNames.footerContainer}>
        <Link
          className={classNames.privacyLink}
          href={termsUrl}
          target="_blank"
        >
          {Messages.footer.termsOfUseAndPrivacy()}
        </Link>
        <Link
          className={classNames.trusteLink}
          id="teconsent"
        >
          <script async type="text/javascript" src={trusteScript} crossOrigin="" />
        </Link>
        <span className={classNames.copyrightText}>
          {Messages.footer.oracleCopyright(copyrightSymbol, year)}
        </span>
      </footer>
    </div>
  );
};
